import axiosPost from "../axiosPost";

export const migraVueloUpd = async ({ migraVueloId, migraVueloEstado }, credentials) => {
    const body = {
        service: "MigraVueloUpd",
        params: { migraVueloId, migraVueloEstado },
    };

    return await axiosPost(body, credentials);
};
